import { StackView, Button } from '@planningcenter/tapestry-react';
import React from 'react';
import 'stream-chat-react';
import '@planningcenter/datetime-fmt';
import '../../../_virtual/moment.js';
import colors from '../../vendor/topbar/colors.js';
import { useChat } from '../../hooks/use_chat.js';
import '../../chat_api_context.js';
import '@planningcenter/url';
import '@planningcenter/jolt-client';
import 'stream-chat';
import { DrawerHeading } from '../../vendor/topbar/components/drawer_heading.js';

const NewChatViewHeader = () => {
    const { navigation } = useChat();
    return (React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1, padding: 2, paddingTop: 1 },
        React.createElement(Button, { icon: {
                color: colors.lightNeutral12,
                name: "general.leftChevron",
            }, marginTop: 0.25, onClick: navigation.switchToNewChatShortcutsView, size: "md", title: "Back to to new conversation shortcuts", tooltip: "Back to to new conversation shortcuts", variant: "naked" }),
        React.createElement(DrawerHeading, null, "New conversation")));
};

export { NewChatViewHeader };
//# sourceMappingURL=header.js.map
